/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../graphql/src/lib/graphql/generated/types'
import { WorkOrderFragmentDoc } from '../../../graphql/WorkOrderFragment.hook'

const defaultOptions = {} as const
export type UpdateWorkOrderMutationVariables = Types.Exact<{
  assigneeId?: Types.InputMaybe<Types.Scalars['ID']['input']>
  description?: Types.InputMaybe<Types.Scalars['String']['input']>
  dueAt?: Types.InputMaybe<Types.Scalars['DateTime']['input']>
  id: Types.Scalars['ID']['input']
  operationalImpact?: Types.InputMaybe<Types.WorkOrderOperationalImpact>
  priority?: Types.InputMaybe<Types.WorkOrderPriority>
  status: Types.WorkOrderStatus
  serviceItem: Types.WorkOrderServiceItem
  updatedAt: Types.Scalars['DateTime']['input']
}>

export type UpdateWorkOrderMutation = {
  __typename?: 'Mutation'
  updateWorkOrder: {
    __typename?: 'WorkOrder'
    createdAt: string
    description: string | null
    dueAt: string | null
    id: string
    operationalImpact: Types.WorkOrderOperationalImpact | null
    orderNumber: number
    priority: Types.WorkOrderPriority | null
    regionID: string | null
    status: Types.WorkOrderStatus
    serviceCategory: Types.WorkOrderServiceCategory | null
    serviceItem: Types.WorkOrderServiceItem
    sourceType: Types.WorkOrderSourceType | null
    statusChangedAt: string | null
    updatedAt: string
    assignee: {
      __typename?: 'BackofficeUser'
      id: string
      firstName: string
      lastName: string
    } | null
    automationRule: {
      __typename?: 'WorkOrderAutomationRule'
      id: string
      referenceNumber: number
      title: string
    } | null
    createdBy: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    source:
      | {
          __typename?: 'RioReport'
          reportId: string
          template: { __typename?: 'RioTemplate'; category: Types.RioCategory }
        }
      | {
          __typename?: 'WorkOrder'
          id: string
          orderNumber: number
          vehicle: { __typename?: 'Vehicle'; id: string } | null
        }
      | { __typename?: 'WorkOrderSourceReference'; id: string }
      | null
    statusChangedBy: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
    vehicle: {
      __typename?: 'Vehicle'
      id: string
      isSelfDriving: boolean
      label: number | null
      sdsProvider: Types.SdsProvider
      baseServiceBreakLocation: {
        __typename?: 'ServiceBreakLocation'
        id: string
        name: string
      } | null
      currentlyLocatedInServiceBreakLocation: {
        __typename?: 'ServiceBreakLocation'
        id: string
        name: string
      } | null
      fleet: { __typename?: 'Fleet'; name: string } | null
      inVehicleLists: Array<{
        __typename?: 'VehicleList'
        id: string
        name: string
      }>
    } | null
  }
}

export const UpdateWorkOrderDocument = gql`
    mutation UpdateWorkOrder($assigneeId: ID, $description: String, $dueAt: DateTime, $id: ID!, $operationalImpact: WorkOrderOperationalImpact, $priority: WorkOrderPriority, $status: WorkOrderStatus!, $serviceItem: WorkOrderServiceItem!, $updatedAt: DateTime!) {
  updateWorkOrder(
    input: {assigneeId: $assigneeId, description: $description, dueAt: $dueAt, id: $id, operationalImpact: $operationalImpact, priority: $priority, status: $status, serviceItem: $serviceItem, updatedAt: $updatedAt}
  ) {
    ...WorkOrder
  }
}
    ${WorkOrderFragmentDoc}`
export type UpdateWorkOrderMutationFn = Apollo.MutationFunction<
  UpdateWorkOrderMutation,
  UpdateWorkOrderMutationVariables
>

/**
 * __useUpdateWorkOrderMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderMutation, { data, loading, error }] = useUpdateWorkOrderMutation({
 *   variables: {
 *      assigneeId: // value for 'assigneeId'
 *      description: // value for 'description'
 *      dueAt: // value for 'dueAt'
 *      id: // value for 'id'
 *      operationalImpact: // value for 'operationalImpact'
 *      priority: // value for 'priority'
 *      status: // value for 'status'
 *      serviceItem: // value for 'serviceItem'
 *      updatedAt: // value for 'updatedAt'
 *   },
 * });
 */
export function useUpdateWorkOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkOrderMutation,
    UpdateWorkOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateWorkOrderMutation,
    UpdateWorkOrderMutationVariables
  >(UpdateWorkOrderDocument, options)
}
export type UpdateWorkOrderMutationHookResult = ReturnType<
  typeof useUpdateWorkOrderMutation
>
export type UpdateWorkOrderMutationResult =
  Apollo.MutationResult<UpdateWorkOrderMutation>
export type UpdateWorkOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkOrderMutation,
  UpdateWorkOrderMutationVariables
>
